import dayjs from 'dayjs';
import { useTranslation } from 'translations/hooks';

import { MobileSingleCardPageWithFilterLayout } from 'business/layout/single-card-page-with-filter-card/mobile';
import { SingleGraphReferenceContextProvider } from 'business/providers/graph-reference';
import { ReportProdAnalyzeGraphContainer } from 'business/shift-report/report-analyze/pages/production-analyze/components/graph-container';
import { ReportProdAnalyzeFiltersProvider } from 'business/shift-report/report-analyze/pages/production-analyze/providers/filters';
import { ReportProdAnalyzeSeriesFilterProvider } from 'business/shift-report/report-analyze/pages/production-analyze/providers/series-filter';
import { GROUP_BY_TYPES_MAP } from 'business/shift-report/report-analyze/pages/production-analyze/types';
import Routes from 'config/routes';
import { GetProductionAnalyzeSeriesQuery } from 'generated/graphql';

import { ReportProdAnalyzeMobileFilters } from './components/production-analyze-filters';

export const MobileProductionAnalyze = ({
  data,
}: {
  data: GetProductionAnalyzeSeriesQuery | undefined;
}) => {
  const { t } = useTranslation();

  return (
    <SingleGraphReferenceContextProvider>
      <ReportProdAnalyzeFiltersProvider
        initialFilters={{
          filterType: 'date',
          dateRange: [dayjs().subtract(6, 'day'), dayjs()],
          groupByType: GROUP_BY_TYPES_MAP.shift,
        }}
      >
        <ReportProdAnalyzeSeriesFilterProvider
          shift={data?.shift.map(({ id }) => id) ?? []}
          team={data?.team.map(({ id }) => id) ?? []}
        >
          <MobileSingleCardPageWithFilterLayout
            title={t('pages.manager.productionAnalyze.title')}
            filters={
              <ReportProdAnalyzeMobileFilters
                teamSwitchEnabled={(data?.team.length ?? 0) > 0}
              />
            }
            mainPageRedirection={Routes.ReportDashboardAnalyze}
          >
            <ReportProdAnalyzeGraphContainer
              shifts={data?.shift || []}
              teams={data?.team || []}
            />
          </MobileSingleCardPageWithFilterLayout>
        </ReportProdAnalyzeSeriesFilterProvider>
      </ReportProdAnalyzeFiltersProvider>
    </SingleGraphReferenceContextProvider>
  );
};
